// extracted by mini-css-extract-plugin
export default {"mobileBreak":"NextVisit_mobileBreak__6Hqiw","nextVisit":"NextVisit_nextVisit__sZSJT","linkWrapper":"NextVisit_linkWrapper__crPAX","btnText":"NextVisit_btnText__JCnUP"};